module.exports = __webpack_public_path__ + "img/tuihuo.69e20c6d.png";